import { RightToWorkDocument } from '@common/components/Job/BaseJobSummary';
import { CajaVariant, isJseSgVariant } from '../../variants';

export const getRightToWorkDocument = (cajaVariant: CajaVariant) =>
  isJseSgVariant(cajaVariant)
    ? RightToWorkDocument.WORK_PASS
    : RightToWorkDocument.WORK_VISA;
